import { useCallback } from 'react';
import { useWixPatternsContainer, useCollectionContext } from '../providers';
import {
  ModalState,
  ImportState,
  ResolvedImportConfig,
  ImportConfig,
  DetectColumnType,
} from '../state';
import type { FieldsSource } from '../types/FieldsSource';
import { FiltersMap } from '../model';

export interface UseImportParams {
  /** Consumer inputs (destination, extra fields, backup, …). The collection,
   *  fields, and create-new-field are read from `fieldsSource`. */
  importInputs?: ImportConfig;
  /** The table's live fields source; `ImportState` builds the config from it. */
  fieldsSource?: FieldsSource;
  /** A fully pre-built config, used instead of building from the inputs/source. */
  config?: ResolvedImportConfig;
  detectColumnType?: DetectColumnType;
  importModalState: ModalState;
}

export function useCreateImport<T = unknown, F extends FiltersMap = FiltersMap>(
  params: UseImportParams,
) {
  const {
    config,
    importInputs,
    fieldsSource,
    detectColumnType,
    importModalState,
  } = params;
  const { showToast, translate, errorHandler, window, httpClient } =
    useWixPatternsContainer();
  const collection = useCollectionContext<T, F>();

  return useCallback(() => {
    return new ImportState({
      config,
      importInputs,
      fieldsSource,
      httpClient,
      detectColumnType,
      collection,
      importModalState,
      showToast,
      translate,
      errorHandler,
      downloadCsv: (content, fileName) => {
        window.download(
          `data:text/csv;charset=utf-8,${encodeURIComponent(content)}`,
          fileName,
        );
      },
    });
  }, []);
}
